import { atomWithStorage } from "jotai/utils";

/**
 * Per-browser opt-in to the search-service appointment list (User settings).
 * Staff reach the list-view read path only when their feature flag is on AND
 * this is set, so a machine can be moved back to the DynamoDB path without
 * touching the flag for everyone. Physicians roll out on their flag alone.
 */
export const appointmentListViewOptInAtom = atomWithStorage<boolean>(
  "appointmentListViewOptIn",
  false,
  undefined,
  // Read storage on first render: the read path is resolved in the same
  // render that enables the list query, so a mount-time hydrate would fire
  // one DynamoDB page before flipping to the list view.
  { getOnInit: true },
);
